import React, { useState } from 'react';
import { Button, Modal, Form, Input, message } from 'antd';
import { AddWorkOrderNotes, CloseCompleteWo } from '../../Services/LocomotiveServices';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';

const WoOrderModalNC = ({ reload, setReload, mode }) => {
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const history = useHistory()
    const { location } = history
    const id = location?.state?.id

    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = async () => {
        try {
            const values = await form.validateFields();


            const payload = {
                close: true,
                CloseoutComment: values?.CloseoutComment,
            };

            const result = await CloseCompleteWo(id, payload);
            if (result?.httpStatus === 200) {
                message.success('Note created successfully!');
                form.setFieldsValue({ CloseoutComment: "" });
                setIsModalOpen(false);
                setReload(!reload);

            }
        } catch (error) {
            console.error('Error:', error);
            message.error('Failed to create note');
        }
    };



    const handleCancel = () => {
        form.resetFields();
        setIsModalOpen(false);
    };

    return (
        <>
            <Button
                style={{
                    background: '#2863ad', color: "white",
                    width: "fit-content", borderRadius: "10px"
                }}
                onClick={showModal}
                disabled={mode === "view-only" ? true : false}
            >
                Closed WO-NC
            </Button>
            <Modal
                title={<span style={{ color: 'Black', fontWeight: '600', fontSize: '18px' }}>Closed WO-NC</span>}
                visible={isModalOpen} onOk={handleOk} okText="Closed WO-NC"
                onCancel={handleCancel}
            >
                <Form form={form} layout="vertical">
                    <Form.Item
                        label="Notes"
                        name="CloseoutComment"
                        rules={[{ required: true, message: 'Please enter notes' }]}
                    >
                        <Input.TextArea />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default WoOrderModalNC;
